export const primary = {
    50:"#f4f8e7" ,
    100:"#e3ecc3" ,
    200:"#d1e09c" ,
    300:"#bdd374" ,
    400:"#aeca54" ,
    500:"#9fc132" ,
    600:"#8fb12a" ,
    700:"#7a9e20" ,
    800:"#658a16" ,
    900:"#406900" ,
    lightMain:"#506600" ,
    lightContainer:"#ccf15d" ,
    darkMain:"#b1d444" ,
    darkContainer:"#3c4d00" ,
}


export const secondary = {
    50:"#e1f5ff" ,
    100:"#b3e4ff" ,
    200:"#4cc2fd" ,
    300:"#4cc2fd" ,
    400:"#24b5fd" ,
    500:"#00a7fb" ,
    600:"#0699ec" ,
    700:"#0b86d7" ,
    800:"#0a75c3" ,
    900:"#0c55a1" ,
    lightMain:"#006496" ,
    lightContainer:"#cce5ff" ,
    darkMain:"#91ccff" ,
    darkContainer:"#004b72" ,
}


export const tertiary = {
    50:"#e5f5ee" ,
    100:"#c0e7d5" ,
    200:"#98d7bb" ,
    300:"#6bc8a1" ,
    400:"#45bc8d" ,
    500:"#08b079" ,
    600:"#00a16e" ,
    700:"#008f60" ,
    800:"#007d54" ,
    900:"#015d3e" ,
    lightMain:"#006c49" ,
    lightContainer:"#74fbbd" ,
    darkMain:"#54dea3" ,
    darkContainer:"#005236" ,
}

export const error = {
    lightMain:"#ba1a1a" ,
    darkMain:"#ffb4ab" ,
}

export const LightError = "#ba1a1a";
export const DarkError = "#ffb4ab";

const ThemeColor = {
    primary:primary ,
    secondary :secondary ,
    tertiary:tertiary ,
    error:error,
}

export default ThemeColor;

